import {AxiosInstance} from 'axios';
import {responseHandler} from './response';
import {LeagueModelParams, LeagueResponse} from "../../types/league";
import {ApiSportsEndPointResponse} from "./types";
import {StandingsResponse} from "../../types/standings";

export const getLeagues = async (client: AxiosInstance, params?: Partial<LeagueModelParams>) => {
    client.defaults.params = params
    return responseHandler<ApiSportsEndPointResponse<LeagueResponse>>(client.get(`/leagues`))
}
/** The competitions the app puts forward, each with its crest and its country */
export const getFeaturedLeagues = async (client: AxiosInstance) => {
    client.defaults.params = {}
    return responseHandler<ApiSportsEndPointResponse<LeagueResponse>>(client.get(`/leagues/featured`))
}

export const getLeagueId = async (client: AxiosInstance, leagueId: number) =>
    responseHandler<ApiSportsEndPointResponse<LeagueResponse>>(client.get(`/leagues/${leagueId}`))

export const getLeagueStandings = async (client: AxiosInstance, leagueId: number) =>
    responseHandler<ApiSportsEndPointResponse<StandingsResponse>>(client.get(`/leagues/${leagueId}/standings`))